import axios from "axios";
import {BODEGA} from "../Constantes";
import {adap_bodega_guia} from "../Adaptadores/adap_bodega_guia";

export const obtenerGuia = async ({pedido, bodega = BODEGA}) => {

    //No olvidarme colocar maximos
    let formatoPedido = adap_bodega_guia({pedido, bodega});

    let data = JSON.stringify(formatoPedido);

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        //url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/5764bf61-62a7-4be0-9db4-31d9292e801b', //test
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/5764bf61-62a7-4be0-9db4-31d9292e801b',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    return axios.request(config)


}